import { WidgetCustomManagedStreamConfig } from 'widgets/streaming/widgetStreamManager/WidgetCustomStreamManager';
import { OrderVolumeStreamManager } from './OrderVolumeStreamManager.ts';

export const orderVolumeProfileStreamConfig: WidgetCustomManagedStreamConfig = {
    channelDestination: 'startOrderVolumeCurveStream',
    managerFactory: (options) => new OrderVolumeStreamManager(options),
};
